import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {Router} from '@angular/router';
import {AuthConfigService} from '@app/auth-config/services/auth-config.service';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {of, Subject, switchMap, takeUntil} from 'rxjs';
import {StorageKeys} from 'src/app/core/constants/storage-keys';
import { Bind } from 'primeng/bind';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    imports: [Bind, ProgressSpinner],
})
export class CallbackComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly authConfigService = inject(AuthConfigService);
  private readonly storage = inject(PlatformStorage);

  private readonly unsubscribe$ = new Subject<void>();
  private readonly unauthorizedRoute = '/auth/unauthorized';
  ngOnInit() {
    this.oidcSecurityService
      .isAuthenticated()
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap(isAuthenticated => {
          if (isAuthenticated) {
            return this.oidcSecurityService.getAccessToken();
          } else {
            this.router.navigate([this.unauthorizedRoute]);
            return of(null);
          }
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: accessToken => {
          if (accessToken) {
            if (!this.authConfigService.isTokenValid()) {
              this.storage.setItem(StorageKeys.accessToken, accessToken);
            }

            const redirectUrl = this.storage.getItem(StorageKeys.redirectUrl);
            if (redirectUrl && typeof redirectUrl === 'string') {
              this.storage.removeItem(StorageKeys.redirectUrl);
              this.router.navigateByUrl(redirectUrl);
            } else {
              this.router.navigate(['/my-orders']);
            }
          } else {
            this.router.navigate([this.unauthorizedRoute]);
          }
        },
        error: () => {
          this.router.navigate([this.unauthorizedRoute]);
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
